// Manage regions lists and behavior
// Does not contain template because of the form validation
import regions from '@/configuration/regions'
import { keys } from 'lodash-es'

export default {
  computed: {
    // List all regions
    regions () { return regions.regions },
    // List all mac version available for the selected region, disable list if no regions selected
    macVersions () {
      if (!this.rfRegion) return []
      return keys(regions.regMacRevCompatibilityMatrix[this.rfRegion])
    },
    // List all revision available for the selected region/mac version, disable list if no regions/mac versions selected
    regionalParameterRevisions () {
      if (!this.rfRegion || !this.macVersion) return []
      return regions.regMacRevCompatibilityMatrix[this.rfRegion][this.macVersion]
    },
    // List all dataRates available for the selected region
    dataRates () {
      if (!this.rfRegion) return []
      return regions.downlinkDatarates[this.rfRegion]
    }
  },

  watch: {
    // Reset on change
    rfRegion () {
      this.macVersion = ''
      this.regParamsRevision = ''
      this.dataRate = ''
      this.cfList = []
    },
    macVersion () {
      this.regParamsRevision = ''
      this.cfList = []

      if (this.regionalParameterRevisions.length === 1) this.regParamsRevision = this.regionalParameterRevisions[0]
    }
  }
}
